<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import MainTitleBack from "@/components/helpers/MainTitleBack";
import TariffPreview from "@/components/tariff/TariffPreview";
import MainButton from "@/components/helpers/MainButton";
import MainCheckbox from "@/components/helpers/MainCheckbox.vue";
import TariffBuyCertificates from "@/components/tariff/TariffBuyCertificates.vue";
import TariffBuyTotalPrice from "@/components/tariff/TariffBuyTotalPrice.vue";
import MainSelect from "@/components/helpers/MainSelect.vue";
import ChangePriceModal from "@/modules/tariff/components/ChangePriceModal.vue";
import { checkTariffBuyError } from "@/modules/tariff/helpers/check-tariff-buy-error";
import LicenseAgreementModal from "@/modules/tariff/components/LicenseAgreementModal.vue";

export default {
  name: "TariffBuy",

  components: {
    LicenseAgreementModal,
    MainCheckbox,
    ChangePriceModal,
    MainSelect,
    TariffBuyTotalPrice,
    TariffBuyCertificates,
    MainTitleBack,
    TariffPreview,
    MainButton,
  },

  data() {
    return {
      isShowChangePriceModal: false,
      isLoading: false,
      selectedCity: null,
      selectedRepresentation: null,
      isShowPopper: false,
      isCheckedCert: false,
      isCertError: false,
      isPaymentSuccess: false,

      certChecked: false,
      isLicenseAgreementModal: false,

      certs: [],
    };
  },

  watch: {
    selectedCity: function () {
      if (this.selectedCity) {
        this.selectedRepresentation = null;
        this.loadRepresentations(this.selectedCity.name);
      }
    },

    certChecked(newValue) {
      if (!newValue) {
        this.setPreviewTariffPrice(null);
      }
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      tariff: (state) => state.tariff.tariff,
      cities: (state) => state.representation.cities,
      representations: (state) => state.representation.representations,
      previewTariffPrice: (state) => state.tariff.previewTariffPrice,
    }),

    ...mapGetters({
      getUserDistributorAccount: "auth/getUserDistributorAccount",
    }),

    isDisabledButtonBuy() {
      const certificatesAmount =
        this.previewTariffPrice?.certificates?.reduce(
          (total, { amount }) => total + Number(amount),
          0
        ) ?? 0;

      const userBalance = this.getUserDistributorAccount?.summary_active ?? 0;
      const price = this.tariff?.user_price ?? 0;
      const hasLocation =
        (!!this.selectedCity && !!this.selectedRepresentation) ||
        !!this.user.representation;

      if (certificatesAmount + userBalance < price) return true;
      if (!hasLocation) return true;
      if (this.isCertError && this.certChecked) return true;

      return false;
    },

    isShowButtonBuyCertificate() {
      const PERMITTED_TARIFFS = [
        "business_d",
        "premium_d",
        "vip_d",
        "vip_gold_d",
      ];

      return PERMITTED_TARIFFS.includes(this.user?.tariff?.code);
    },
  },

  methods: {
    ...mapMutations({
      setPreviewTariffPrice: "tariff/SET_PREVIEW_TARIFF_PRICE",
    }),

    ...mapActions({
      loadTariff: "tariff/loadTariff",
      buyTariff: "tariff/buyTariff",
      loadCities: "representation/loadCities",
      loadRepresentations: "representation/loadRepresentations",
      storeRepresentation: "representation/storeRepresentation",
      checkUser: "auth/checkUser",
      loadDocuments: "loadDocuments",
      createNotification: "createNotification",

      loadLicenseAgreement: "tariffDocs/loadLicenseAgreement",
      loadDistributionAgreement: "tariffDocs/loadDistributionAgreement",
      loadCertificatePurchase: "tariffDocs/loadCertificatePurchase",
    }),

    showPopper() {
      const certificatesAmount =
        this.previewTariffPrice?.certificates?.reduce((total, currentValue) => {
          return total + +currentValue.amount;
        }, 0) ?? 0;

      if (
        this.getUserDistributorAccount?.summary_active + certificatesAmount <
        this.tariff?.user_price
      ) {
        this.isShowPopper = true;
      }
    },
    //
    // async buyTariffRequest(tariffId) {
    //   this.isLoading = true;
    //
    //   try {
    //     if (!this.user.representation) {
    //       await this.storeRepresentation(this.selectedRepresentation.id);
    //     }
    //
    //     await this.buyTariff({
    //       tariffId,
    //       certificates:
    //         this.$refs.tariffBuyCertificates?.formattedCertificates ?? [],
    //     });
    //
    //     await this.checkUser();
    //     this.isPaymentSuccess = true;
    //   } catch (error) {
    //     const isModalOpen = checkTariffBuyError(error);
    //
    //     if (isModalOpen) {
    //       this.isShowChangePriceModal = true;
    //       await this.loadTariff(tariffId);
    //     }
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },

    changeCheckedCert(val) {
      this.isCheckedCert = val;
    },

    isCertErrorHandler(isError) {
      this.isCertError = isError;
    },

    setCertsHandler(certs) {
      this.certs = certs;
    },

    tariffSuccessPay() {
      this.isPaymentSuccess = true;
      this.certChecked = false;
    },

    async loadDefaultDocuments() {
      const promises = [
        this.loadLicenseAgreement().then(),
        this.loadDistributionAgreement().then(),
        this.loadCertificatePurchase().then(),
      ];

      await Promise.all(promises);
    },
  },

  beforeMount() {
    this.setPreviewTariffPrice(null);

    if (!this.$route.params?.tariffId) {
      this.$router.push({ name: "Tariffs" });
    } else {
      this.loadTariff(this.$route.params.tariffId);
      this.loadCities();
      this.loadDocuments({ page: "tariff" });
    }
  },

  async mounted() {
    await this.loadDefaultDocuments();
  },
};
</script>

<template>
  <div class="tariffs-buy default-content-padding">
    <div class="tariffs-buy__wrapper">
      <MainTitleBack title="Покупка тарифа" href="Tariffs" />

      <div v-if="tariff" class="tariffs-buy__preview">
        <TariffPreview :tariff="tariff" />
      </div>

      <template v-if="!user.representation && !isPaymentSuccess">
        <div class="tariffs-buy__representation representation">
          <h2>Адрес представительства</h2>

          <p>
            Выбирая представительство, вы прикрепляетесь к офису дистрибьюторов
            в своем регионе. Благодаря этому мы собираем статистику роста
            дистрибьюции
          </p>

          <span class="divider" />

          <div class="representation__selectors">
            <MainSelect
              :selected-option.sync="selectedCity"
              :options="cities"
              :title="'Ваш город'"
              :style-type="'background-gray'"
              :is-set-default="false"
            />

            <MainSelect
              v-if="selectedCity"
              :selected-option.sync="selectedRepresentation"
              :options="representations"
              :title="'Адрес'"
              :style-type="'background-gray'"
              :is-set-default="false"
            />
          </div>
        </div>
      </template>

      <MainCheckbox
        v-if="!isPaymentSuccess"
        id="cert-checked"
        v-model="certChecked"
        class="cert-checked"
        title="Хочу воспользоваться сертификатом для покупки тарифа"
      />

      <TariffBuyCertificates
        v-if="tariff && !isPaymentSuccess && certChecked"
        ref="tariffBuyCertificates"
        class="tariffs-buy__certificates"
        :tariff-id="+$route.params.tariffId"
        :is-add-disabled="isCertError"
        @checkedCert="changeCheckedCert"
        @isCertError="isCertErrorHandler"
        @setCerts="setCertsHandler"
      />

      <TariffBuyTotalPrice
        v-if="
          previewTariffPrice &&
          previewTariffPrice?.certificates?.length &&
          !isPaymentSuccess &&
          certChecked
        "
        :tariff="tariff"
        :price-info="previewTariffPrice"
      />

      <LicenseAgreementModal
        v-model="isLicenseAgreementModal"
        :tariff="tariff"
        :certificates="certs"
        :cert-checked="certChecked"
        :selected-representation="selectedRepresentation"
        @success="tariffSuccessPay"
        @changePrice="isShowChangePriceModal = true"
      />

      <div v-if="!isPaymentSuccess" class="tariffs-buy__button-wrapper">
        <VDropdown
          popper-class="tariffs-buy__dropdown"
          :triggers="[]"
          :distance="12"
          :placement="'auto'"
          :shown.sync="isShowPopper"
          @mouseenter.native="showPopper"
        >
          <MainButton
            class="tariffs-buy__button"
            title="Купить"
            :color="'dark'"
            :disabled="isDisabledButtonBuy"
            :loading="isLoading"
            @click="isLicenseAgreementModal = true"
          />

          <template #popper>
            <div class="tariffs-buy__popper">
              <h4>Недостаточно средств</h4>
              <p>
                На дистрибьюторском счете недостаточно средств, необходимо
                пополнить счет или добавить сертификат(-ы)
              </p>

              <div class="tariffs-buy__popper-buttons">
                <MainButton
                  :title="'Пополнить баланс'"
                  :color="'gold'"
                  @click="$router.push({ name: 'Balance' })"
                />
                <MainButton
                  v-if="isShowButtonBuyCertificate && !isPaymentSuccess"
                  :title="'Купить сертификат'"
                  :color="'dark'"
                  @click="$router.push({ name: 'Certificates' })"
                />
              </div>
            </div>
          </template>
        </VDropdown>
      </div>
    </div>

    <ChangePriceModal v-model="isShowChangePriceModal" />
  </div>
</template>

<style scoped lang="scss">
.tariffs-buy {
  min-height: 100%;
  background-color: $background-white;
  padding-top: 48px;
  padding-bottom: 48px;

  &__wrapper {
    max-width: 600px;
  }

  &__preview {
    margin: 0 0 $space-xxl;
  }

  .representation {
    margin-bottom: 32px;

    > h2 {
      @include body-1-bold;
      color: $dark-primary;
      margin-bottom: 8px;
    }

    > p {
      @include text-2;
      color: $dark-fifth;
    }

    > .divider {
      margin-top: 24px;
      margin-bottom: 24px;
    }

    &__selectors {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  &__certificates {
    margin-bottom: 56px;

    @media (max-width: 900px) {
      margin-bottom: 40px;
    }

    @media (max-width: 425px) {
      margin-bottom: 32px;
    }
  }

  &__checkboxes {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__button-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
    z-index: 100;
  }

  &__button {
    max-width: 160px;
    width: 160px;
  }

  &__checkbox {
    &::v-deep {
      span {
        max-width: 400px !important;
      }
    }
  }
}

@media (max-width: 900px) {
  .tariffs-buy {
    padding-top: 40px;
    padding-bottom: calc(40px + 48px + 24px);

    &__wrapper {
      max-width: none;
    }

    &__button-wrapper {
      position: fixed;
      bottom: 24px;
      width: 100%;
      display: block;
      max-width: calc(100% - 96px);
    }

    &__button {
      width: 100%;
      max-width: none;
    }
  }
}

@media (max-width: 576px) {
  .tariffs-buy {
    &__button-wrapper {
      max-width: calc(100% - 64px);
    }
  }
}

@media (max-width: 425px) {
  .tariffs-buy {
    &__button-wrapper {
      max-width: calc(100% - 48px);
    }
  }
}

@media (max-width: 375px) {
  .tariffs-buy {
    &__button-wrapper {
      max-width: calc(100% - 32px);
    }
  }
}

.cert-checked {
  width: 100%;
  margin-bottom: 32px;
}
</style>
